export default __webpack_public_path__ + "static/media/Case-Transmissao-AoVivo.e09351e0.jpg";